﻿$.fn.dxCtrlContentSondagePageQuestionItem = function custom_dxCtrlContentSondagePageQuestionItem(option) {
    if (option == "instance") {
        return this.instance;
    }
    else {
        this.addClass("dx-dxctrlcontentsondagepagequestionitem dx-ctrl");
        this.createInstance(new cdxCtrlContentSondagePageQuestionItem(this, option));
    }
    return this;
}

window.cdxCtrlContentSondagePageQuestionItem = function (container, option) {
    var Me = this;


    this.option = function (name, value) {
        if (typeof value == 'undefined') {
            return option[name];
        }
        else {
            option[name] = value;
        }
    }

    function mConstruit() {
        container.empty()

        container.css("font-family", "barlow condensed")
        switch (option.dataQuestion.type) {
            case "ouinon":
                $("<span style='margin-right:7px;' class='dx-theme-accent-as-text-color'><i class='fas fa-toggle-off'></i></span>").appendTo(container)
                break;
            case "chk":
                $("<span style='margin-right:7px;' class='dx-theme-accent-as-text-color'><i class='fas fa-square-check'></i></span>").appendTo(container)
                break;
            case "radio":
                $("<span style='margin-right:7px;' class='dx-theme-accent-as-text-color'><i class='fas fa-circle-dot'></i></span>").appendTo(container)
                break;
            case "text":
                $("<span style='margin-right:7px;' class='dx-theme-accent-as-text-color'><i class='fas fa-a'></i></span>").appendTo(container)
                break;
            case "textbox":
                $("<span style='margin-right:7px;' class='dx-theme-accent-as-text-color'><i class='fas fa-i-cursor'></i></span>").appendTo(container)
                break;
        }

        if (option.dataQuestion.id_page == -1) {
            if (typeof option.dataQuestion.tx_satisfaction_min != 'undefined') {
                var $Satis = $("<span style='margin-right:7px;'>" + option.dataQuestion.tx_satisfaction_min + "/" + option.dataQuestion.tx_satisfaction_max + "%</span>").appendTo(container)
                $Satis.attr("title", "Cette question est affichée si le taux de satisfaction du répondeur entre " + option.dataQuestion.tx_satisfaction_min + "% et " + option.dataQuestion.tx_satisfaction_max + "%")
            }
        }

        $("<span style='font-weight:bold;'></span>").appendTo(container).text($("<div>").html(option.dataQuestion.text_intro || "").text())

        switch (option.dataQuestion.type) {
            case "chk":
            case "radio":
                option.dataQuestion.lst_phrase.forEach(function (phrase) {
                    $("<span> &bull; </span>").appendTo(container)
                    $("<span></span>").appendTo(container).text(phrase.txt)
                })
                break;
        }

        container.attr("title", container.html())
        if (option.dataQuestion.id_page == -1) {
            if (typeof option.dataQuestion.tx_satisfaction_min != 'undefined') {
                container.attr("title", "<div style='text-align:left;'>" + container.html() + "<br/>" + "Cette question est affichée si le taux de satisfaction du répondeur entre " + option.dataQuestion.tx_satisfaction_min + "% et " + option.dataQuestion.tx_satisfaction_max + "%.</div>")
            }
        }
    }
      
    this.element = function () { return container }

    mConstruit();
}